/* eslint-disable react/prop-types */
import React from 'react';
const SortIndicator = ({ currentSort, accessor }) => {
    const iStyle = {
        paddingLeft: '5px',
    };
    if (currentSort && currentSort.key === accessor) {
        if (currentSort && currentSort.desc) {
            return React.createElement("i", { className: 'fa fa-chevron-up', style: iStyle });
        }
        return React.createElement("i", { className: 'fa fa-chevron-down', style: iStyle });
    }
    return React.createElement("i", { className: 'fa fa-sort', style: iStyle });
};
export { SortIndicator, };
